import React, { useEffect, useState } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import DatePicker from "react-datepicker";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import {
  addYears,
  subDays,
  startOfMonth,
  endOfMonth,
  format,
  getDaysInMonth,
  addMonths,
} from "date-fns";
import { Table, Form, FormControl, InputGroup } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

const CalenderEdit = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit Calendar"));
    fetchHRCalender();
  }, []);
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [holidayLineErrors, setHolidayLineErrors] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");
  const [errors, setErrors] = useState({
    Code: false,
    Name: false,
    CompanyID: false,
    PayrollMethod: false,
    StartDate: false,
  });
  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    CompanyID: "",
    StartDate: "",
    EndDate: "",
    PayrollMethod: "",
    WorkingDays: "",
    calendarHolidayLines: [
      {
        LineNo: 1 || "",
        BranchID: "",
        HolidayID: "",
        FromDate: "",
        ToDate: "",
        IsOptional: 1,
        Description: "",
      },
    ],
    calendarMonthLines: [
      {
        MonthName: "",
        StartDate: "",
        EndDate: "",
        PayableDays: "",
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);
  const [calenderData, setCalenderData] = useState([]);
  const [calendarDetails, setCalendarDetails] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  console.log("check CompanyList", companyList);
  const [pageLoading, setPageLoading] = useState(true);
  const [existingHolidayDates, setExistingHolidayDates] = useState([]);
  const [payrolMethod, setPayrolMethod] = useState([]);
  const [branchOpt, setBranchOpt] = useState([]);
  const [holidayOpt, setHolidayOpt] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    const errorMessages = [];

    if (!formData.Code) {
      newErrors.Code = true;
      errorMessages.push("Code is required.");
    }
    if (!formData.Name) {
      newErrors.Name = true;
      errorMessages.push("Name is required.");
    }
    if (!formData.CompanyID) {
      newErrors.CompanyID = true;
      errorMessages.push("Company is required.");
    }
    // if (!formData.WorkingDays) {
    //   newErrors.WorkingDays = true;
    //   errorMessages.push("Working Days are required.");
    // }
    if (!formData.PayrollMethod) {
      newErrors.PayrollMethod = true;
      errorMessages.push("Payroll Method is required.");
    }
    if (!formData.StartDate) {
      newErrors.StartDate = true;
      errorMessages.push("Start Date is required.");
    }

    const lineErrors = formData.calendarHolidayLines.map((line, index) => {
      const lineError = {};
      if (!line.BranchID) {
        // Changed from CompanyID to BranchID
        lineError.BranchID = true;
        errorMessages.push(`Row ${index + 1}: Branch is required.`);
      }
      if (!line.HolidayID) {
        // Make sure this matches your field name
        lineError.HolidayID = true;
        errorMessages.push(`Row ${index + 1}: Holiday is required.`);
      }
      if (!line.FromDate) {
        lineError.FromDate = true;
        errorMessages.push(`Row ${index + 1}: From Date is required.`);
      }
      return lineError;
    });

    setErrors(newErrors);
    setHolidayLineErrors(lineErrors);

    return errorMessages;
  };
  const fetchHRCalender = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster`);
      if (response.status === 200) {
        const calenderData = response?.data?.header;
        setCalenderData(calenderData || []);
      } else {
        console.error(
          "Failed to fetch Course. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Course:", error);
    }
  };
  const handleStartDateChange = (date) => {
    setSelectedDate(date);

    if (date) {
      const newEndDate = subDays(addYears(date, 1), 1);
      setEndDate(newEndDate);

      // Generate month details
      const details = [];
      for (let i = 0; i < 12; i++) {
        const currentMonth = addMonths(date, i);
        const monthName = format(currentMonth, "MMMM yyyy");
        const monthStartDate = format(
          startOfMonth(currentMonth),
          "dd-MMM-yyyy"
        );
        const monthEndDate = format(endOfMonth(currentMonth), "dd-MMM-yyyy");
        const monthDays = getDaysInMonth(currentMonth);

        details.push({
          monthName,
          monthStartDate,
          monthEndDate,
          monthDays,
        });
      }

      setCalendarDetails(details);

      // Update form data while preserving other fields
      setFormData((prev) => ({
        ...prev,
        StartDate: format(date, "dd-MMM-yyyy"),
        EndDate: format(newEndDate, "dd-MMM-yyyy"),
        calendarMonthLines: details.map((detail) => ({
          MonthName: detail.monthName,
          StartDate: detail.monthStartDate,
          EndDate: detail.monthEndDate,
          PayableDays: detail.monthDays,
        })),
      }));
    } else {
      // Handle null/empty date case
      setEndDate(null);
      setCalendarDetails([]);
      setFormData((prev) => ({
        ...prev,
        StartDate: "",
        EndDate: "",
        calendarMonthLines: [],
      }));
    }
  };

  const handleInputChange = (name, selectedOption) => {
    setFormData({
      ...formData,
      [name]: selectedOption.value,
    });

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Name") {
      // Extract just the year part from the input (removing any letters, spaces, or hyphens)
      const inputYear = value.replace(/[^\d]/g, "");

      // Check if this year exists in any calendar name
      const isDuplicate = calenderData.some((calendar) => {
        // Extract year from existing calendar names
        const existingYear = calendar.Name.replace(/[^\d]/g, "");
        return existingYear === inputYear && inputYear !== "";
      });

      if (isDuplicate) {
        toast.error("Calendar for this year already exists");
        setFormData((prev) => ({ ...prev, Name: "" }));
        return;
      }
    }
    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: false,
      }));
    }
  };

  const handleLineChange = (e, index) => {
    const { name, value } = e.target;
    const lines = [...formData.calendarHolidayLines];
    lines[index][name] = value;
    setFormData({
      ...formData,
      calendarHolidayLines: lines,
    });

    if (holidayLineErrors[index]?.[name]) {
      setHolidayLineErrors((prev) => {
        const newErrors = [...prev];
        newErrors[index] = {
          ...newErrors[index],
          [name]: false,
        };
        return newErrors;
      });
    }
  };

  const handleSelectChange = (selectedOption, name, index) => {
    const lines = [...formData.calendarHolidayLines];
    lines[index][name] = selectedOption.value;
    setFormData({
      ...formData,
      calendarHolidayLines: lines,
    });

    // Clear the error for this field if it exists
    if (holidayLineErrors[index]?.[name]) {
      setHolidayLineErrors((prev) => {
        const newErrors = [...prev];
        newErrors[index] = {
          ...newErrors[index],
          [name]: false,
        };
        return newErrors;
      });
    }
  };

  // const handleResDateChange = (event, index) => {
  //   const { name, value } = event.target;
  //   const updatedLines = [...formData.calendarHolidayLines];
  //   updatedLines[index] = {
  //     ...updatedLines[index],
  //     [name]: value,
  //   };

  //   setFormData((prevState) => ({
  //     ...prevState,
  //     calendarHolidayLines: updatedLines,
  //   }));

  //   if (holidayLineErrors[index]?.[name]) {
  //     setHolidayLineErrors((prev) => {
  //       const newErrors = [...prev];
  //       newErrors[index] = {
  //         ...newErrors[index],
  //         [name]: false,
  //       };
  //       return newErrors;
  //     });
  //   }
  // };
  const handleResDateChange = (event, index) => {
    const { name, value } = event.target;
    const updatedLines = [...formData.calendarHolidayLines];
    
    // Store the original value before validation
    const originalValue = updatedLines[index][name];
    updatedLines[index][name] = value;

    const validateDate = (fieldName, dateValue) => {
      if (!dateValue) return true; // Skip validation if no date value

      // Check if date is within calendar range
      if (formData.StartDate && formData.EndDate) {
        const selectedDate = new Date(dateValue);
        const startDate = new Date(formData.StartDate);
        const endDate = new Date(formData.EndDate);

        if (selectedDate < startDate || selectedDate > endDate) {
          updatedLines[index][fieldName] = originalValue;

          toast.error(
            `Holiday ${fieldName} must be between Calendar StartDate and Calendar EndDate`,
            {
              position: "top-right",
              autoClose: 3000,
            }
          );

          setFormData((prevState) => ({
            ...prevState,
            calendarHolidayLines: updatedLines,
          }));
          return false;
        }
      }

      // Check for duplicate dates in API data (existingHolidayDates)
      const isDuplicateInApiData = existingHolidayDates.includes(dateValue);
      
      // Check for duplicate dates in current form data (excluding current row)
      const isDuplicateInFormData = updatedLines.some((line, i) => {
        if (i === index) return false; // Skip current row
        
        return (
          (line.FromDate && line.FromDate === dateValue) ||
          (line.ToDate && line.ToDate === dateValue)
        );
      });

      if (isDuplicateInApiData || isDuplicateInFormData) {
        updatedLines[index][fieldName] = originalValue;

        toast.error(`This date (${dateValue}) is already used in another holiday!`, {
          position: "top-right",
          autoClose: 3000,
        });

        setFormData((prevState) => ({
          ...prevState,
          calendarHolidayLines: updatedLines,
        }));
        return false;
      }

      return true;
    };

    if ((name === "FromDate" || name === "ToDate") && value) {
      if (!validateDate(name, value)) return;
    }

    // Clear error for this field
    setHolidayLineErrors((prev) => {
      const newErrors = [...prev];
      if (!newErrors[index]) newErrors[index] = {};
      newErrors[index][name] = false;
      return newErrors;
    });

    setFormData((prevState) => ({
      ...prevState,
      calendarHolidayLines: updatedLines,
    }));
  };

const handleAddLine = () => {
  const currentLines = [...formData.calendarHolidayLines];
  if (currentLines.length > 0) {
    const lastLine = currentLines[currentLines.length - 1];
    // Check BranchID instead of CompanyID
    if (!lastLine.BranchID || !lastLine.HolidayID || !lastLine.FromDate) {
      toast.error("Please fill Current Row before adding new row");
      return;
    }
  }
  const newLineNo = currentLines.length + 1;
  currentLines.push({
    LineNo: newLineNo,
    BranchID: "",
    HolidayID: "",
    FromDate: "",
    ToDate: "",
    Description: "",
    // CanDelete: 1,
  });
  setFormData({
    ...formData,
    calendarHolidayLines: currentLines,
  });
};

  const handleDeleteLine = (index) => {
    const updatedLines = formData.calendarHolidayLines.filter(
      (_, i) => i !== index
    );
    setFormData({
      ...formData,
      calendarHolidayLines: updatedLines,
    });
  };

  const fetchCalenderDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster`);
      // Company List Option
      if (response?.status === 200) {
        setPageLoading(false);
        const company = response?.data?.companyList;
        const options = company.map((comp) => ({
          value: comp.value,
          label: comp.text,
        }));
        setCompanyList(options);
        // Payroll Method
        const payrol = response?.data?.payrollMethod;
        const payrolMethod = payrol.map((pay) => ({
          value: pay.value,
          label: pay.text,
        }));
        setPayrolMethod(payrolMethod);
        // Branch Option
        const branch = response?.data?.branches;
        const branchOption = branch.map((branch) => ({
          value: branch.value,
          label: branch.text,
        }));
        setBranchOpt(branchOption);
        // Holiday Option
        const holiday = response?.data?.holidayList;
        const HolidayOption = holiday.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setHolidayOpt(HolidayOption);
        setOptionsLoaded(true); // Indicate that options have been loaded
      }
    } catch (error) {
      console.error("Error fetching JobType options:", error);
    }
  };

  useEffect(() => {
    fetchCalenderDetails();
  }, []);

  const fetchCalendarData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}calendarmaster/${id}`);
      if (response.status === 200) {
        const calendarData = response?.data?.calendar || {};
        const calenderHoliday = response?.data?.calendarHoliday || [];
        const calenderMonths = response?.data?.calendarMonth || [];

        const CalenderMonthsLine = calenderMonths.map((data) => ({
          MonthName: data.MonthName,
          StartDate: data.StartDate
            ? moment(data.StartDate).format("DD-MM-YYYY")
            : "",
          EndDate: data.EndDate,
          PayableDays: data.PayableDays,
        }));

        const CalenderHolidays = calenderHoliday.map((data) => ({
          LineNo: data.LineNo,
          BranchID: data.BranchID,
          HolidayID: data.HolidayID,
          CanDelete: 0,
          FromDate: data.FromDate
            ? moment(data.FromDate).format("DD-MM-YYYY")
            : "",
          Description: data.Description,
          ToDate: data.ToDate ? moment(data.ToDate).format("DD-MM-YYYY") : "",
        }));

        const selectedCompany = companyList.find(
          (company) => company.value === calendarData.CompanyID
        );
        console.log("selectedCompany", selectedCompany);

        const payrolmtd = payrolMethod.find(
          (company) => company.value === calendarData.PayrollMethod
        );

        // Create initial form data
        const initialFormData = {
          id: id,
          Code: calendarData.Code || "",
          Name: calendarData.Name || "",
          Description: calendarData.Description || "",
          CompanyID: selectedCompany || null,
          StartDate: calendarData.StartDate
            ? moment(calendarData.StartDate).format("DD-MMM-YYYY")
            : "",
          EndDate: calendarData.EndDate
            ? moment(calendarData.EndDate).format("DD-MMM-YYYY")
            : "",
          PayrollMethod: payrolmtd || null,
          WorkingDays: calendarData.WorkingDays || "",
          calendarHolidayLines: CalenderHolidays || [],
          calendarMonthLines: CalenderMonthsLine || [],
        };
          const allDates = [];
        CalenderHolidays.forEach(holiday => {
          if (holiday.FromDate) allDates.push(holiday.FromDate);
          if (holiday.ToDate) allDates.push(holiday.ToDate);
        });
        setExistingHolidayDates(allDates);

        setFormData(initialFormData);

        // If there's a start date, trigger the handleStartDateChange
        if (calendarData.StartDate) {
          const startDate = moment(calendarData.StartDate).toDate();
          handleStartDateChange(startDate);
        }
      } else {
        console.error(
          "Failed to fetch calendar details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching calendar details:", error);
    }
  };

  useEffect(() => {
    if (optionsLoaded) {
      fetchCalendarData(id);
    }
  }, [id, optionsLoaded]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationMessages = validateForm();

    if (validationMessages.length > 0) {
      validationMessages.forEach((msg) => toast.error(msg));
      return;
    }
    try {
      const requestPayload = {
        Code: formData.Code,
        Name: formData.Name,
        Description: formData.Description,
        CompanyID: formData.CompanyID.value,
        StartDate: formData.StartDate,
        EndDate: formData.EndDate,
        PayrollMethod: formData.PayrollMethod.value,
        WorkingDays: formData.WorkingDays,
        calendarHolidayLines: formData.calendarHolidayLines,
        calendarMonthLines: formData.calendarMonthLines,
      };

      const response = await PostServiceCaller(
        `${API_URL}calendarmaster/${id}`,
        requestPayload,
        "put"
      );

      if (response.status === 200) {
        toast.success("Form Update successfully!");
        setFormData(initialFormData);
        navigate("/hrCalendar");
      } else {
        toast.error("Failed to submit form. Please try again.");
        console.error(
          "Failed to submit form. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      toast.error("Failed to submit form. Please try again.");
      console.error("Error submitting form:", error);
    }
  };
  const openDeleteModal = (type, item) => {
  setDeleteType(type);
  setSelectedDeleteItem(item);
  setShowDeleteModal(true);
};
const handleModalDelete = () => {
  if (selectedDeleteItem) {
    if (deleteType === "CalendarEdit") {
      handleDeleteLine(selectedDeleteItem.index);
    }
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
    setDeleteType("");
  }
};
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
    setDeleteType("");
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <form onSubmit={handleSubmit}>
              {/* Tabs Section Start */}
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="calender-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#calender"
                    type="button"
                    role="tab"
                    aria-controls="calender"
                    aria-selected="true"
                  >
                    Calendar Details/Payroll Settings & Company Financial
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="holiday-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#holiday"
                    type="button"
                    role="tab"
                    aria-controls="holiday"
                    aria-selected="false"
                  >
                    Calendar Holidays
                  </button>
                </li>
              </ul>
              {/* Tabs Body Section  */}
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="calender"
                  role="tabpanel"
                  aria-labelledby="calender-tab"
                >
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">
                        Code <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="Code"
                        onChange={handleChange}
                        value={formData.Code}
                        className={`form-control ${
                          errors.Code ? "is-invalid" : ""
                        }`}
                      />
                      {errors.Code && (
                        <div className="error">Code is required</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className={`form-control ${
                          errors.Name ? "is-invalid" : ""
                        }`}
                        name="Name"
                        onChange={handleChange}
                        value={formData.Name}
                      />
                      {errors.Name && (
                        <div className="error">Name is required</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Company <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={companyList}
                        name="CompanyID"
                        className={errors.CompanyID ? "is-invalid" : ""}
                        onChange={(selectedOption) =>
                          handleInputChange("CompanyID", selectedOption)
                        }
                        value={formData.CompanyID}
                      />
                      {errors.CompanyID && (
                        <div className="error" style={{ display: "block" }}>
                          Company is required
                        </div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Payroll Method <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={payrolMethod}
                        name="PayrollMethod"
                        value={formData.PayrollMethod}
                        className={errors.PayrollMethod ? "is-invalid" : ""}
                        onChange={(selectedOption) =>
                          handleInputChange("PayrollMethod", selectedOption)
                        }
                      />
                      {errors.PayrollMethod && (
                        <div className="error" style={{ display: "block" }}>
                          Payroll Method is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-3">
                      <label class="form-label">
                        Fixed Payable Days{" "}
                      </label>
                      <input
                        className={`form-control text-end ${
                          errors.WorkingDays ? "is-invalid" : ""
                        }`}
                        name="WorkingDays"
                        onChange={handleChange}
                        value={formData.WorkingDays}
                        disabled={formData.PayrollMethod !== 1018}
                      />
                      {/* {errors.WorkingDays && (
                        <div className="error">
                          Fixed Payable Days is required
                        </div>
                      )} */}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">Description</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Description"
                        onChange={handleChange}
                        value={formData.Description}
                      />
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">
                        Start Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        name="StartDate"
                        handleChange={(e) => {
                          const date = e.target?.value
                            ? new Date(e.target.value)
                            : e;
                          handleStartDateChange(date);
                        }}
                        value={formData.StartDate}
                        placeholderText="Start Date"
                        className={`form-control ${
                          errors.StartDate ? "is-invalid" : ""
                        }`}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd-MMM-yyyy"
                      />
                      {errors.StartDate && (
                        <div className="error">Start Date is required</div>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label class="form-label">End Date</label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        dateFormat="dd-MMM-yyyy"
                        className="form-control"
                        placeholderText="End date"
                        value={formData.EndDate}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade show"
                  id="holiday"
                  role="tabpanel"
                  aria-labelledby="holiday-tab"
                >
                  <div className="row">
                    <div className="text-end my-1">
                      <button
                        type="button"
                        onClick={handleAddLine}
                        className="custom-btn-sm pull-right"
                      >
                        <i className="fa fa-plus"></i>&nbsp;Add
                      </button>
                    </div>
                    <div className="col-md-12">
                      <div className="table-responsive poc-head rounded">
                        <table
                          id="poctable_head"
                          className="table table-bordered"
                        >
                          <thead id="thcolor" className="text-center">
                            <tr>
                              <th>Sr. No.</th>
                              <th>
                                Branch<span className="text-danger">*</span>
                              </th>
                              <th>
                                Holiday<span className="text-danger">*</span>
                              </th>
                              <th>
                                From Date<span className="text-danger">*</span>
                              </th>
                              <th>To Date</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData?.calendarHolidayLines?.map(
                              (line, index) => {
                                const lineError =
                                  holidayLineErrors[index] || {};
                                return (
                                  <tr key={index} className="bg-white">
                                    <td>{index + 1}</td>
                                    <td>
                                      <Select
                                        options={branchOpt}
                                        name="BranchID"
                                        onChange={(selectedOption) =>
                                          handleSelectChange(
                                            selectedOption,
                                            "BranchID",
                                            index
                                          )
                                        }
                                        value={branchOpt.find(
                                          (opt) => opt.value === line.BranchID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        menuPlacement="top"
                                        className={
                                          holidayLineErrors[index]?.BranchID
                                            ? "is-invalid"
                                            : ""
                                        }
                                      />
                                      {lineError.CompanyID && (
                                        <div className="error">
                                          Branch is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <Select
                                        options={holidayOpt}
                                        name="HolidayID"
                                        onChange={(selectedOption) =>
                                          handleSelectChange(
                                            selectedOption,
                                            "HolidayID",
                                            index
                                          )
                                        }
                                        value={holidayOpt.find(
                                          (opt) => opt.value === line.HolidayID
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={{
                                          menuPortal: (base) => ({
                                            ...base,
                                            zIndex: 9999,
                                          }),
                                        }}
                                        menuPlacement="top"
                                        className={
                                          lineError.HolidayID
                                            ? "is-invalid"
                                            : ""
                                        }
                                      />
                                      {lineError.HolidayID && (
                                        <div className="error d-block">
                                          Holiday is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        name="FromDate"
                                        handleChange={(e) =>
                                          handleResDateChange(e, index)
                                        }
                                        value={line.FromDate}
                                        placeholderText="From Date"
                                        className={`form-control ${
                                          lineError.FromDate ? "is-invalid" : ""
                                        }`}
                                      />
                                      {lineError.FromDate && (
                                        <div className="error d-block">
                                          From Date is required
                                        </div>
                                      )}
                                    </td>
                                    <td>
                                      <CustomDatePicker
                                        name="ToDate"
                                        handleChange={(e) =>
                                          handleResDateChange(e, index)
                                        }
                                        value={line.ToDate}
                                        placeholderText="To Date"
                                        className="form-control"
                                      />
                                    </td>
                                    <td>
                                      <textarea
                                        type="text"
                                        name="Description"
                                        value={line.Description}
                                        className="form-control"
                                        onChange={(e) =>
                                          handleLineChange(e, index)
                                        }
                                      ></textarea>
                                    </td>
                                    <td>
                                      <div
                                  onClick={() => openDeleteModal("CalendarEdit", { index })}
                                        className={
                                          line.CanDelete === 0
                                            ? `text-center mt-3 disabled-icon`
                                            : "text-center mt-3"
                                        }
                                      >
                                        <i
                                          className="bi bi-trash"
                                          style={{ fontSize: "1.2rem" }}
                                        ></i>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {selectedDate && (
                <div>
                  <h6 className="mt-2">
                    <b>Calendar Holiday </b>
                  </h6>
                  <Table striped bordered hover>
                    <thead id="thcolor" className="text-center">
                      <tr>
                        <th>Month Name</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Payable Days</th>
                      </tr>
                    </thead>
                    <tbody>
                      {calendarDetails?.map((details, index) => (
                        <tr key={index}>
                          <td>{details.monthName}</td>
                          <td style={{ textAlign: "center" }}>
                            {details.monthStartDate}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {details.monthEndDate}
                          </td>
                          <td className="text-center">{details.monthDays}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
              <div className="text-end me-2 mt-2">
                <button
                  type="button"
                  className="cancel-btn me-2"
                  onClick={() => {
                    navigate("/hrCalendar");
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="custom-btn me-2">
                  Submit
                </button>
              </div>
            </form>
          </div>
             <DeleteModal
                      show={showDeleteModal}
                      onClose={handleDeleteClose}
                      onConfirm={handleModalDelete}
                      message="Are you sure you want to delete this item?"
                    />
        </div>
      </>
    );
  }
};

export default CalenderEdit;
